jQuery(document).ready(function($){
    if($(window).width() <= 1024){
        $('.collection .contains-card--product.contains-card--standard').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: '<button id="slick-prev" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            nextArrow: '<button id="slick-next" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;    transform: rotate(180deg);&#10;"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            ]
        });
    }

    if($(window).width() <= 650){
        $('.bottom-bar .flex').slick({
          speed: 4000,             // Long duration for smooth continuous scroll
          autoplay: true,
          autoplaySpeed: 0,        // No delay between slides
          cssEase: 'linear',       // Smooth linear motion, no easing
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

    }
    // if($(window).width() <= 1024){
       $('.collection-list.contains-card.contains-card--collection').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 7,
        arrows: true,
        prevArrow: '<button id="slick-prev" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button id="slick-next" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;    transform: rotate(180deg);&#10;"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button> </div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 3,
              arrows: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1
            }
          }
        ]
      });
    // }

    if($(window).width() <= 1200){
        $('.product-info-boxes').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: '<button id="slick-prev" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            nextArrow: '<button id="slick-next" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;    transform: rotate(180deg);&#10;"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, centerPadding: '60px' } }
            ]
        });
    }

    // $('.collection-list.contains-card.contains-card--collection').slick({
    //     slidesToShow: 7,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     autoplay: false,
    //     autoplaySpeed: 3000,
    //     arrows: false,
    //     dots: false,
    //     responsive: [
    //     { breakpoint: 1024, settings: { slidesToShow: 5 } },
    //     { breakpoint: 768, settings: { slidesToShow: 2.5 } },
    //     { breakpoint: 600, settings: { slidesToShow: 2.5 } },
    //     { breakpoint: 480, settings: { slidesToShow: 1.2 } }
    //     ]
    // });

    if($(window).width() <= 1024){
      setTimeout(() => {
        
      
        $('product-recommendations.related-products .product-grid').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: '<button id="slick-prev" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            nextArrow: '<button id="slick-next" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;    transform: rotate(180deg);&#10;"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            ]
        });

        }, 10000);
    }

    if($(window).width() <= 650){
     
        
      
        $('.blog__posts.articles-wrapper').slick({
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<button id="slick-prev" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            nextArrow: '<button id="slick-next" class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;    transform: rotate(180deg);&#10;"> <path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            dots: false,
            // responsive: [
            // { breakpoint: 1024, settings: { slidesToShow: 4 } },
            // { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            // { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            // { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            // ]
        });

        
    }

   $('.association_boxes').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    arrows: false,
   });
   
})

document.addEventListener("DOMContentLoaded", function () {
    if(window.outerWidth < 750){
    const headings = document.querySelectorAll(".footer-block .heading-with-arrow");

    headings.forEach((heading) => {
        heading.addEventListener("click", function () {
        const parentBlock = heading.closest(".footer-block");
        const content = parentBlock.querySelector(".footer-block__details-content");

        // Toggle visibility
        content.classList.toggle("active");

        // Optional: toggle arrow rotation
        heading.classList.toggle("open");
        });
    });
  }
});